module.exports = __webpack_public_path__ + "img/pdjh_charact_2.ca547bea.svg";